var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIconSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3437 18.5C16.8142 18.5 18.0012 17.302 18.0012 15.8306V5.16939C18.0012 3.69797 16.8142 2.5 15.3437 2.5H9.00584C7.53529 2.5 6.3483 3.69797 6.3483 5.16939V6.43771C6.3483 6.86126 6.69109 7.20462 7.11395 7.20462C7.53681 7.20462 7.8796 6.86126 7.8796 6.43771V5.16939C7.8796 4.5394 8.38667 4.03383 9.00584 4.03383H15.3437C15.9629 4.03383 16.4699 4.5394 16.4699 5.16939V15.8306C16.4699 16.4606 15.9629 16.9661 15.3437 16.9661H9.00584C8.38667 16.9661 7.8796 16.4606 7.8796 15.8306V14.5623C7.8796 14.1387 7.53681 13.7954 7.11395 13.7954C6.69109 13.7954 6.3483 14.1387 6.3483 14.5623V15.8306C6.3483 17.302 7.53529 18.5 9.00584 18.5H15.3437ZM4.23833 12.9044C3.92499 13.2114 3.42211 13.2063 3.11512 12.8929L1.93746 11.6909L1.93746 11.6909C1.32684 11.0676 1.32684 10.0637 1.93746 9.44047L1.93746 9.44046L3.11512 8.2384C3.42211 7.92506 3.92499 7.9199 4.23833 8.22689C4.55168 8.53387 4.55683 9.03675 4.24985 9.3501L3.83706 9.77144H10.7261C11.1648 9.77144 11.5204 10.127 11.5204 10.5657C11.5204 11.0044 11.1648 11.36 10.7261 11.36H3.83715L4.24985 11.7812C4.55683 12.0946 4.55168 12.5974 4.23833 12.9044Z",
    fill: "#EB5757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIconSm);
export default __webpack_public_path__ + "static/media/logout-icon-sm.f9e29f80bc46a2c1c3f8de89aa732439.svg";
export { ForwardRef as ReactComponent };